<div id="titulo">
    <h2>Gestión Petición</h2>
    <span style="flex: 1 1 auto;"></span>
    <h2 id="btnCerrar" mat-flat-button style="margin-right: 20px;" (click)="onClose()" >X</h2>
</div>
<div style="padding: 20px;padding-top: 15px;">
    <div id="tablaContainer">
      <table mat-table class="tabla-art" [dataSource]="dataSource"  style="min-width: auto; font-size: 17px; letter-spacing: 0;">
        <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
          <th mat-header-cell *matHeaderCellDef >{{column.replaceAll("_"," ")}}</th>
          <td mat-cell *matCellDef="let element" (dblclick)="volcarSeleccion(element, column)">{{element[column]}}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[5, 10]" [pageSize]="10" [length]="dataSource.data.length" [showFirstLastButtons]="true"></mat-paginator>
    </div>
</div>

